import { Stack, Typography, MenuItem, useTheme } from '@mui/material';
import { useSmartNavigate } from 'hooks/useSmartNavigate';
import { DropdownItem } from 'types/header';

export const NavItemChildDesktop = ({
  item,
}: // closeDropdown,
{
  item: DropdownItem;
  closeDropdown: () => void;
}) => {
  // const baseUrl = process.env.REACT_APP_DRUPAL_BASE_URL;
  const baseUrlFederlegno = process.env.REACT_APP_FEDERLEGNOARREDO;
  const smartNavigate = useSmartNavigate();
  const theme = useTheme();

  return (
    <Stack
      sx={{
        overflowY: 'auto',
        // TODO: verificare larghezza massima
        maxWidth: '100%',
      }}
      flexWrap={'wrap'}
      flexGrow={1}
      columnGap={1.5}
      direction={'column'}
    >
      {item.children?.map(child => {
        return (
          <MenuItem
            key={child.title}
            onClick={() => {
              // const path = makePath(DASHBOARD, `${child.path}`);
              if (child.path)
                smartNavigate(`${baseUrlFederlegno}${child.path}`);
              // closeDropdown();
            }}
            sx={{
              maxWidth: '100%',
              px: 0.5,
              py: 1,
              borderRadius: 1,

              '&:hover': {
                backgroundColor: theme.palette.primary.lighter,
              },
            }}
          >
            <Stack width={'100%'} sx={{ maxWidth: '100%' }}>
              <Typography
                variant="body1"
                align="left"
                sx={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  maxWidth: '160px',
                  // fontWeight: 600,
                  color: 'text.primary',
                  '&:hover': { color: theme.palette.primary.main },
                }}
              >
                {child.title}
              </Typography>
              {child.subtitle && (
                <Typography
                  variant="body1"
                  // color={'grey.600'}
                  sx={{
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    maxWidth: '100%',
                  }}
                >
                  {child.subtitle}
                </Typography>
              )}
            </Stack>
          </MenuItem>
        );
      })}
    </Stack>
  );
};
